var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物品名称", prop: "goodsName" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  type: "text",
                  disabled: _vm.isDetail,
                  maxlength: "50",
                  clearable: "",
                  placeholder: "请输入物品名称"
                },
                model: {
                  value: _vm.childData.goodsName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "goodsName", $$v)
                  },
                  expression: "childData.goodsName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物品类型", prop: "goodsType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "280px" },
                  attrs: {
                    placeholder: "请选择物品类型",
                    disabled: _vm.isDetail,
                    clearable: ""
                  },
                  model: {
                    value: _vm.childData.goodsType,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "goodsType", $$v)
                    },
                    expression: "childData.goodsType"
                  }
                },
                _vm._l(_vm.typeOptions, function(item) {
                  return _c("el-option", {
                    key: item.dicValue,
                    attrs: { label: item.typeName, value: item.dicValue }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "遗失地点", prop: "lostPlace" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.isDetail,
                  maxlength: "50",
                  type: "text",
                  placeholder: "请输入遗失地点"
                },
                model: {
                  value: _vm.childData.lostPlace,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "lostPlace", $$v)
                  },
                  expression: "childData.lostPlace"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "遗失时间", prop: "lostDate" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "280px" },
                attrs: {
                  type: "date",
                  placeholder: "选择遗失时间",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  clearable: ""
                },
                model: {
                  value: _vm.childData.lostDate,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "lostDate", $$v)
                  },
                  expression: "childData.lostDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系人名称", prop: "lostUserName" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.isDetail,
                  maxlength: "10",
                  type: "text",
                  placeholder: "请输入联系人名称"
                },
                model: {
                  value: _vm.childData.lostUserName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "lostUserName", $$v)
                  },
                  expression: "childData.lostUserName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系方式", prop: "lostUserPhone" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.isDetail,
                  maxlength: "11",
                  type: "text",
                  placeholder: "请输入联系方式"
                },
                model: {
                  value: _vm.childData.lostUserPhone,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "lostUserPhone", $$v)
                  },
                  expression: "childData.lostUserPhone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物品图片" } },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    name: "files",
                    "list-type": "picture-card",
                    headers: _vm.importHeaders,
                    "on-success": _vm.handleSuccess,
                    action: _vm.uploadUrl,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    "before-upload": _vm.beforeUpload,
                    limit: 5,
                    "on-exceed": _vm.handleExceed,
                    "file-list": _vm.files
                  }
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": true,
            title: "预览"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }